<script setup lang="ts">
import IconAlertTriangle from '../Icons/IconAlertTriangle.vue'

defineProps({
    text: {
        type: String,
        required: true
    }
})
const emits = defineEmits(['showAlertPopup'])

const displayLearnMoreButton = ref(true)
const alertText = useTemplateRef('alertText')

onMounted(() => {
    if (alertText.value) {
        displayLearnMoreButton.value =
            alertText.value.clientHeight !== alertText.value.scrollHeight
    }
})
</script>

<template>
    <div
        class="w-full text-thirteen-exploitation tracking-light leading-4 bg-red-l-500 text-white flex justify-between items-center p-4"
    >
        <div class="flex gap-2 items-center">
            <IconAlertTriangle class="min-w-20 text-white h-4" is-solid />
            <p ref="alertText" class="font-normal line-clamp-1">
                {{ text }}
            </p>
        </div>
        <p
            v-if="displayLearnMoreButton"
            class="font-bold text-red-l-100 cursor-pointer ml-3"
            @click="emits('showAlertPopup')"
        >
            {{ $t('word.more') }}
        </p>
    </div>
</template>
